export default __webpack_public_path__ + "static/media/img5.784ad90a.jpeg";